import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSupportWidgetContextV2 } from "../context/supportWidgetContext";
import { getLocalStorage, setLocalStorage } from "../utils/storageUtils";

const FULL_SCREEN_AVAILABLE_PATHS = [
  "/form",
  "/posts/",
  "/news/",
  "/report_bug_form",
  "/message_confirmation",
  "/conversations/",
] as const;

interface RecentLocationWrapperProps {
  children: React.ReactNode;
}

const isFullScreenAvailableOnPath = (pathname: string): boolean =>
  FULL_SCREEN_AVAILABLE_PATHS.some(path =>
    path.endsWith("/") ? pathname.startsWith(path) : pathname === path,
  );

const RecentLocationWrapper = ({
  children,
}: RecentLocationWrapperProps): JSX.Element => {
  const location = useLocation();
  const { collapseWidget } = useSupportWidgetContextV2();

  useEffect(() => {
    setLocalStorage({
      ...getLocalStorage(),
      location: location.pathname,
    });
    if (!isFullScreenAvailableOnPath(location.pathname)) {
      collapseWidget();
    }
  }, [location.pathname, collapseWidget]);

  return <>{children}</>;
};

export default RecentLocationWrapper;
